(function () {
  var SELECTORS = {
    header: '.ctr-header',
    hamburger: '.ctr-header__hamburger',
    mobileMenu: '.ctr-header__mobile-menu',
    langToggle: '[data-ctr-lang-toggle]',
  };

  function initHeader(scope) {
    var header = scope.querySelector(SELECTORS.header);
    if (!header) return;

    var hamburger = header.querySelector(SELECTORS.hamburger);
    var mobileMenu = header.querySelector(SELECTORS.mobileMenu);

    function toggleMenu() {
      if (!mobileMenu) return;
      var isOpen = hamburger.getAttribute('aria-expanded') === 'true';
      if (isOpen) {
        mobileMenu.classList.remove('ctr-header__mobile-menu--open');
        hamburger.setAttribute('aria-expanded', 'false');
      } else {
        mobileMenu.classList.add('ctr-header__mobile-menu--open');
        hamburger.setAttribute('aria-expanded', 'true');
      }
    }

    if (hamburger) hamburger.addEventListener('click', toggleMenu);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mobileMenu && mobileMenu.classList.contains('ctr-header__mobile-menu--open')) {
        mobileMenu.classList.remove('ctr-header__mobile-menu--open');
        hamburger.setAttribute('aria-expanded', 'false');
      }
    });

    /* Sticky show/hide on scroll */
    var stickyType = header.dataset.stickyType;
    if (stickyType === 'on-scroll-up') {
      var lastScrollY = window.scrollY;
      var ticking = false;

      window.addEventListener('scroll', function () {
        if (!ticking) {
          window.requestAnimationFrame(function () {
            var currentScrollY = window.scrollY;
            var menuOpen = mobileMenu && mobileMenu.classList.contains('ctr-header__mobile-menu--open');
            if (!menuOpen && currentScrollY > lastScrollY && currentScrollY > 100) {
              header.classList.add('ctr-header--hidden');
            } else {
              header.classList.remove('ctr-header--hidden');
            }
            lastScrollY = currentScrollY;
            ticking = false;
          });
          ticking = true;
        }
      });
    }

    /* Language selector toggles (desktop dropdown + mobile panel) */
    var section = header.closest('[class*="section-"]') || header.parentElement;

    section.querySelectorAll(SELECTORS.langToggle).forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!expanded));
      });
    });

    section.querySelectorAll('[data-ctr-mobile-lang-toggle]').forEach(function (btn) {
      var panel = btn.parentElement.querySelector('.ctr-header__mobile-lang-panel');
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!expanded));
        if (panel) {
          panel.classList.toggle('ctr-header__mobile-lang-panel--open', !expanded);
        }
      });
    });

    document.addEventListener('click', function (e) {
      section.querySelectorAll(SELECTORS.langToggle).forEach(function (btn) {
        if (!btn.contains(e.target)) {
          btn.setAttribute('aria-expanded', 'false');
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initHeader(document);
    });
  } else {
    initHeader(document);
  }

  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      initHeader(e.target);
    });
  }
})();
